import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AccessibilityBar from './AccessibilityBar';
import EmergencyAlerts from './EmergencyAlerts';
import { useSite } from '../context/SiteContext';
import { Container } from 'react-bootstrap';

const Layout = () => {
  const { config, loading } = useSite();

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <div className={`site-wrapper template-${config?.active_template?.layout_type || 'modern'}`}>
      <AccessibilityBar />
      <Header />
      <EmergencyAlerts />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
